import {
  isDirectPublicTamiImageUrl as coreIsDirectPublicTamiImageUrl,
  normalizeLegacyTamiS3ImageUrl as coreNormalizeLegacyTamiS3ImageUrl,
  parseTamiS3PublicImageUrl as coreParseTamiS3PublicImageUrl,
  resolveMediaImageUrl as coreResolveMediaImageUrl,
} from "@tami/core";

/**
 * A regra mora em `@tami/core` (`dashboard/media-image-url.ts`), a mesma do
 * app e do desktop. Aqui fica o que é do web: o bucket vem da env e o proxy é
 * a rota `/api/social-images` deste Next. As assinaturas continuam as de antes.
 */
export { TAMI_PUBLIC_IMAGE_PATH_PREFIXES, TAMI_S3_BUCKET_NAMES } from "@tami/core";

const getTargetTamiBucket = (): string =>
  process.env.NEXT_PUBLIC_TAMI_S3_BUCKET?.trim() ||
  (process.env.NODE_ENV === "production" ? "tami-prod" : "tami-stage");

/** Reescreve host de buckets legados para o bucket Tami atual (mesma key no S3). */
export const normalizeLegacyTamiS3ImageUrl = (url: string): string =>
  coreNormalizeLegacyTamiS3ImageUrl(url, getTargetTamiBucket());

export const parseTamiS3PublicImageUrl = (
  url: string,
): { bucket: string; key: string } | null =>
  coreParseTamiS3PublicImageUrl(url, getTargetTamiBucket());

export const isDirectPublicTamiImageUrl = (
  url: string | null | undefined,
): boolean => coreIsDirectPublicTamiImageUrl(url, getTargetTamiBucket());

export type ResolveMediaImageUrlOptions = {
  /** html2canvas exige same-origin ou CORS — proxy evita bloqueio no S3 público. */
  forCanvas?: boolean;
  proxyPath?: string;
};

export const resolveMediaImageUrl = (
  url: string | null | undefined,
  options?: ResolveMediaImageUrlOptions,
): string | null =>
  coreResolveMediaImageUrl(url, {
    targetBucket: getTargetTamiBucket(),
    proxyPath: options?.proxyPath ?? "/api/social-images",
    forCanvas: options?.forCanvas,
  });
